<script setup lang="ts">
type Props = {
  htmlMessage: string;
  callToAction?: {
    text: string;
    path: string;
  };
};

const props = defineProps<Props>();
const router = useRouter();
const localePath = useLocalePath();

const showCallToAction = computed(() => {
  if (!props.callToAction?.text) return false;

  const localePathToPush = localePath(props.callToAction.path);
  if (!localePathToPush) return false;

  const isAlreadyAtThePath =
    localePathToPush === router.currentRoute.value.path;

  return !isAlreadyAtThePath;
});

const onClickCallToAction = () => {
  if (!props.callToAction) return;
  router.push(localePath(props.callToAction.path));
};
</script>

<template>
  <div>
    <!-- eslint-disable-next-line vue/no-v-html -->
    <div v-html="htmlMessage" />
    <button
      v-if="showCallToAction"
      class="underline capitalize"
      @click="onClickCallToAction"
    >
      {{ callToAction?.text || "" }}
    </button>
  </div>
</template>
